import {getMyState} from '@/api/participant.js';
import {CONTEST_ACTIONS} from '@/hooks/contest/contestActions.js';
import {APP_STEPS} from '@/hooks/contest/contestSteps.js';
import {PARTICIPANT_STATUS, CONTEST_STATUS} from '@/hooks/contest/contestStatus.js';

// --- A. LOGIQUE PURE (ROUTER) ---
export const determineNextStep = (userStatus, contestStatus, hasError) => {
    if (hasError || !userStatus) {
        return contestStatus === CONTEST_STATUS.OPEN ? APP_STEPS.WELCOME : APP_STEPS.MISSED;
    }

    switch (userStatus) {
        case PARTICIPANT_STATUS.MISSED_QUIZ:         return APP_STEPS.QUIZ;
        case PARTICIPANT_STATUS.CAN_JOIN:
        case PARTICIPANT_STATUS.CAN_JOIN_QUIZ:       return APP_STEPS.WELCOME;
        case PARTICIPANT_STATUS.JOINED_PENDING:
        case PARTICIPANT_STATUS.JOINED_PENDING_QUIZ: return APP_STEPS.LEADERBOARD;
        case PARTICIPANT_STATUS.WON:                 return APP_STEPS.RESULT_WIN;
        case PARTICIPANT_STATUS.LOST:                return APP_STEPS.RESULT_LOSE;
        case PARTICIPANT_STATUS.MISSED:              return APP_STEPS.MISSED;
        default:                                     return APP_STEPS.WELCOME;
    }
};

// --- B. ACTION (HYDRATEUR) ---
const restoreUserSession = (dispatch, myState) => {
    if (!myState) return;

    const savedScore = myState.bet ? {team1: myState.bet.home, team2: myState.bet.away} : null;

    dispatch({
        type: CONTEST_ACTIONS.UPDATE_USER_INFOS,
        payload: {
            info: {pseudo: myState.pseudo, email: myState.email, quizPoints: myState.quizPoints ?? null},
            score: savedScore
        }
    });

    if (myState.reward) {
        dispatch({type: CONTEST_ACTIONS.SET_USER_REWARD, payload: myState.reward});
    }

    dispatch({type: CONTEST_ACTIONS.SET_HALF_TIME_REWARD, payload: myState.halfTimeReward ?? null});

    // Penalty volet: the live step (reconstructs the shootout screen on refresh) + the won lot.
    dispatch({type: CONTEST_ACTIONS.SET_PENALTY_STATE, payload: myState.penalty ?? null});
    dispatch({type: CONTEST_ACTIONS.SET_PENALTY_REWARD, payload: myState.penaltyReward ?? null});
};

// --- C. ORCHESTRATEUR PRINCIPAL ---
export const syncUserContestStatus = async (contestId, contestStatus, dispatch) => {
    try {
        const {data: myState, error} = await getMyState(contestId);

        // 1. On restaure les données si elles existent
        if (myState && !error) {
            restoreUserSession(dispatch, myState);
        }

        // On mémorise si le user est déjà en session (cookie valide) → skip StepForm + captcha au prono
        // et s'il peut encore booster son score via le quiz (prono posé, quiz dispo non joué)
        dispatch({
            type: CONTEST_ACTIONS.UPDATE_USER_INFOS,
            payload: {
                isAnonymous: !!error,
                canPlayQuiz: myState?.status === PARTICIPANT_STATUS.JOINED_PENDING_QUIZ,
                hasZone: myState?.hasZone ?? false
            }
        });

        // 2. On décide de la page
        const nextStep = determineNextStep(myState?.status, contestStatus, !!error);

        // 3. On applique la navigation
        dispatch({type: CONTEST_ACTIONS.SET_STEP, payload: nextStep});

        return {status: myState?.status || PARTICIPANT_STATUS.CAN_JOIN, step: nextStep, isAnonymous: !!error};

    } catch (e) {
        console.error("Erreur syncUserContestStatus", e);
        throw e;
    }
};